import React from 'react';
import './Showreel.css';
import SiteHeader from '../Views/SiteHeader';
import ContactFooter from '../Components/ContactFooter';

const Videography = () => {
  return (
    <div className="showreel-page">
      <SiteHeader />

      <main className="showreel-main">
        <div className="showreel-layout">
          <aside className="showreel-sidebar">
            <h1 className="showreel-title">Videography</h1>
            <p className="showreel-meta">Travel · Personal</p>

            <div className="showreel-info">
              <div className="showreel-info__head">Project Information</div>
              <p className="showreel-info__copy">
                A personal travel film shot, edited and graded myself. Edited in
                Premiere Pro, graded in DaVinci Resolve.
              </p>
            </div>
          </aside>

          <div className="showreel-content">
            <div className="showreel-video-container">
              <video
                controls
                playsInline
                preload="metadata"
                className="showreel-video"
                poster="/images/for-friends-poster.jpg"
              >
                <source src="/videos/for-friends.mp4" type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>
          </div>
        </div>
      </main>

      <ContactFooter />
    </div>
  );
};

export default Videography;
